import { PermissionGuard } from '@/app/auth/guards/permission.guard';
import { inject } from '@angular/core';
import { Route } from '@angular/router';
import { surveyFormCanDeactivateGuard } from './shared/guards/survey-form.guard';
import { surveyDetailCanDeactivateGuard } from './shared/guards/survey-detail.guard';

export const SurveyRoutes: Route = {
    path: 'survey',
    data: { title: 'survey' },
    children: [
        {
            path: '',
            pathMatch: 'full',
            redirectTo: 'contract-survey',
        },
        {
            path: 'contract-survey',
            loadComponent: () =>
                import('./pages/contract-survey/contract-survey.component').then((m) => m.ContractSurveyComponent),
            data: { title: 'contract-survey' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'contract-status',
            loadComponent: () =>
                import('./pages/contract-status/contract-status.component').then((m) => m.ContractStatusComponent),
            data: { title: 'contract-survey-status' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'questions',
            loadComponent: () =>
                import('./pages/questions/questions.component').then((m) => m.QuestionsComponent),
            data: { title: 'survey-questions' },
            // canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'baseline-survey',
            loadComponent: () =>
                import('./pages/baseline-survey/baseline-survey.component').then((m) => m.BaselineSurveyComponent),
            data: { title: 'baseline-survey' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'baseline-status',
            loadComponent: () =>
                import('./pages/baseline-status/baseline-status.component').then((m) => m.BaselineStatusComponent),
            data: { title: 'baseline-survey-status' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'contract-form',
            loadComponent: () =>
                import('./pages/survey-form/survey-form.component').then((m) => m.SurveyFormComponent),
            data: { title: 'contract-survey', isBaseline: false },
            // canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
            canDeactivate: [surveyFormCanDeactivateGuard],
        },
        {
            path: 'baseline-form',
            loadComponent: () =>
                import('./pages/survey-form/survey-form.component').then((m) => m.SurveyFormComponent),
            data: { title: 'baseline-survey', isBaseline: true },
            // canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
            canDeactivate: [surveyFormCanDeactivateGuard],
        },
        {
            path: ':id',
            loadComponent: () =>
                import('./pages/survey-detail/survey-detail.component').then((m) => m.SurveyDetailComponent),
            data: { title: 'survey-form-title' },
            canDeactivate: [surveyDetailCanDeactivateGuard],
        },
    ],
};
